export default __webpack_public_path__ + "static/media/FirstAid-icon.e91604fe.svg";